<template>
  <div class="container-fluid py-5">

    <div class="">
      <!-- Rounded tabs -->
      <ul id="myTab" role="tablist"
          class="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
        <li class="nav-item flex-sm-fill" v-for="issue in issues" :key="issue.id">
          <router-link :to="{name : issue.issueName}" class="nav-link border-0 text-uppercase font-weight-bold"
                       href="#" :class="{ 'active': isRouteActive(issue.issueName)}">
            {{ issue.issueName }}
          </router-link>
        </li>

        <!--        <li class="nav-item flex-sm-fill" v-for="issue in issues" :key="issue.id">-->
        <!--          &lt;!&ndash;            <a id="makuhari-tab" data-toggle="tab" href="#makuhari" role="tab" aria-controls="contact"&ndash;&gt;-->
        <!--          &lt;!&ndash;               aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">{{ issue.issueName }}</a>&ndash;&gt;-->

        <!--          <router-link :to="{name : 'RohqCircular'}" class="nav-link border-0 text-uppercase font-weight-bold"-->
        <!--                       href="#" :class="{ 'active': isRouteActive(issue.issueName)}">-->
        <!--            {{ issue.issueName }}-->
        <!--          </router-link>-->

        <!--        </li>-->

      </ul>


      <div id="myTabContent" class="tab-content">
        <div class="tab-pane fade px-4 py-5 show active">


          <!-- Lined tabs-->
          <div class="p-5 bg-white rounded shadow mb-5">
            <h3><span class="badge badge-pill badge-secondary mb-5">KOBE CIRCULAR</span></h3>

            <ul id="myTab2" role="tablist"
                class="nav nav-tabs nav-pills with-arrow lined flex-column flex-sm-row text-center">
              <li class="nav-item flex-sm-fill" v-for="sub_issue in subIssues" :key="sub_issue.id">
                <a id="home2-tab" data-toggle="tab" href="#home2" role="tab" aria-controls="home2" aria-selected="true"
                   class="nav-link text-uppercase font-weight-bold mr-sm-3 rounded-0"
                   :class="{ 'active': isRouteActive(sub_issue.subIssueName)}">{{ sub_issue.subIssueName }}</a>
              </li>
            </ul>

            <div id="myTab2Content" class="tab-content">
              <div id="home2" role="tabpanel" aria-labelledby="home-tab" class="tab-pane fade px-4 py-5 show active">

                <div class="row mb-5">
                  <div class="col-lg-8 mx-auto">
                    <form action="">
                      <div class="input-group mb-4 border rounded-pill p-2">
                        <input type="search" placeholder="Search .. " aria-describedby="button-addon3"
                               class="form-control bg-none border-0">
                        <div class="input-group-append border-0">
                          <button id="button-addon3" type="button" class="btn btn-link text-primary">
                            <font-awesome-icon icon="search" />
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- End -->
                  </div>
                </div>

                <table class="table">
                  <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Lettter Number</th>
                    <th scope="col">Date</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Cat</th>
                    <th scope="col">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>INF-22-004.pdf</td>
                    <td>2022-03-18</td>
                    <td>
                      <div class="row">
                        <div class="col">
                          ADDITIONAL DUES WILL BE APPLIED IN CASE OF PENALTY FOR FAILURE TO REPORT DEFECTS FOR SUEZ ..
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">

                          <a href="#" class="badge badge-primary">INF-22-004-A1.pdf</a>
                          <a href="#" class="badge badge-primary ml-2">I-02-Emergency</a>
                          <a href="#" class="badge badge-primary ml-2">I-02-P1 List of Emer</a>
                          <a href="#" class="badge badge-primary ml-2">I-02-P2 Example Sent</a>

                        </div>
                      </div>
                    </td>
                    <td>INF</td>
                    <td>
                      <div class="dropdown dropleft">
                        <button class="btn btn-success dropdown-toggle "
                                type="button"
                                id="userDetailsDropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          Details
                        </button>
                        <div class="dropdown-menu" aria-labelledby="userDetailsDropdown">
                          <base-outline-primary-btn class="sm w-100 my-1 border-0 px-5"
                                                    data-toggle="modal" data-target="#updateUserModal">
                            <font-awesome-icon icon="eye" />
                            <span class="ml-1">View</span>
                          </base-outline-primary-btn>
                          <hr class="m-0" />
                          <base-outline-success-btn class="sm w-100 my-1 border-0 px-5"
                                                    data-toggle="modal" data-target="#updateUserModal">
                            <font-awesome-icon icon="angle-down" />
                            <span class="ml-1">Download</span>
                          </base-outline-success-btn>
                          <hr class="m-0" />
                          <base-outline-info-btn class="border-0 ">
                            <font-awesome-icon icon="angles-down" />
                            <span class="ml-1"> Download with all attachments</span>
                          </base-outline-info-btn>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">1</th>
                    <td>KRBS-22-010.pdf</td>
                    <td>2022-03-14</td>
                    <td>
                      <div class="row">
                        <div class="col">
                          REVISION OF SMS-G-01-F1 LEDGER FOR ADMINISTRATION OF CERTIFICATES VER 5.05 AND KRBS ONLIN..
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">

                          <a href="#" class="badge badge-primary ml-2">CREW-22-001_A3_JP_KA  </a>
                          <a href="#" class="badge badge-primary ml-2">KRBS_LPL_2021_021-A3 </a>
                          <a href="#" class="badge badge-primary ml-2">KRBS-22-003-A2-CA ap</a>
                          <a href="#" class="badge badge-primary ml-2">I-04-P2-Flow chart o  </a>
                          <a href="#" class="badge badge-primary ml-2">CREW-21-010-A4_FAQ a  </a>

                        </div>
                      </div>
                    </td>
                    <td>OFF</td>
                    <td>
                      <div class="dropdown dropleft">
                        <button class="btn btn-success dropdown-toggle "
                                type="button"
                                id="userDetailsDropdown2"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          Details
                        </button>
                        <div class="dropdown-menu" aria-labelledby="userDetailsDropdown">
                          <base-outline-primary-btn class="sm w-100 my-1 border-0 px-5"
                                                    data-toggle="modal" data-target="#updateUserModal">
                            <font-awesome-icon icon="eye" />
                            <span class="ml-1">View</span>
                          </base-outline-primary-btn>
                          <hr class="m-0" />
                          <base-outline-success-btn class="sm w-100 my-1 border-0 px-5"
                                                    data-toggle="modal" data-target="#updateUserModal">
                            <font-awesome-icon icon="angle-down" />
                            <span class="ml-1">Download</span>
                          </base-outline-success-btn>
                          <hr class="m-0" />
                          <base-outline-info-btn class="border-0 ">
                            <font-awesome-icon icon="angles-down" />
                            <span class="ml-1"> Download with all attachments</span>
                          </base-outline-info-btn>
                        </div>
                      </div>
                    </td>
                  </tr>

                  </tbody>
                </table>

                <div class="d-flex justify-content-center">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                      <li class="page-item"><a class="page-link" href="#">1</a></li>
                      <li class="page-item"><a class="page-link" href="#">2</a></li>
                      <li class="page-item"><a class="page-link" href="#">3</a></li>
                      <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                  </nav>
                </div>

              </div>
              <div id="profile2" role="tabpanel" aria-labelledby="profile-tab" class="tab-pane fade px-4 py-5">
                <p class="leade font-italic">content 2</p>
              </div>
              <div id="contact2" role="tabpanel" aria-labelledby="contact-tab" class="tab-pane fade px-4 py-5">
                <p class="leade font-italic">content 3</p>
              </div>
            </div>
          </div>
          <!-- End lined tabs -->


        </div>
        <div id="rohq" role="tabpanel" class="tab-pane fade px-4 py-5">
          <p class="text-muted">rohq</p>
        </div>
        <div id="makuhari" role="tabpanel" class="tab-pane fade px-4 py-5">
          <p class="text-muted">makuhari</p>
        </div>
        <div id="manual_procedure" role="tabpanel" class="tab-pane fade px-4 py-5">
          <p class="text-muted">Manual Procedure</p>
        </div>
        <div id="handbook" role="tabpanel" class="tab-pane fade px-4 py-5">
          <p class="text-muted">handbook</p>
        </div>
      </div>
      <!-- End rounded tabs -->
    </div>

  </div>
</template>

<script>
import {AppMixins} from '@/mixins/app.mixins';

export default {
  name: 'BaseIssue',

  mixins: [AppMixins],

  inject: ['issues', 'subIssues'],

  /** props **/
  props: {
    componentName: {
      type: String,
    },
    tabName: {
      type: String,
    },

  },

  data() {
    return {};
  },

};
</script>

<style scoped>

/* Rounded tabs */
@media (min-width: 576px) {
  .rounded-nav {
    border-radius: 50rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-nav .nav-link {
    border-radius: 50rem !important;
  }
}

/* With arrow tabs */
.with-arrow .nav-link.active {
  position: relative;
}

.with-arrow .nav-link.active::after {
  content: '';
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #2b90d9;
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}

/* lined tabs */
.lined .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
}

.lined .nav-link:hover {
  border: none;
  border-bottom: 3px solid transparent;
}

.lined .nav-link.active {
  background: none;
  color: #555;
  border-color: #2b90d9;
}

.nav-link {
  font-size: 14px;
}

/*

*/

/*body {*/
/*  background: #304352;*/
/*  background: -webkit-linear-gradient(to right, #304352, #d7d2cc);*/
/*  background: linear-gradient(to right, #304352, #d7d2cc);*/
/*  min-height: 100vh;*/
/*}*/

.nav-pills .nav-link {
  color: #555;
}

.text-uppercase {
  letter-spacing: 0.1em;
}


/*Search*/

.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}


.form-control::placeholder {
  font-size: 0.95rem;
  color: #007bff;
  font-style: italic;
}

/*Table Border Color*/


</style>
